import { TextSize } from "theme";

export type ALLOWED_TEXT_OVERRIDE_ELEMENTS =
	| "h1"
	| "h2"
	| "h3"
	| "h4"
	| "h5"
	| "h6"
	| "p"
	| "span"
	| "label"
	| "legend";

export const fontSizeToElementMap: Record<TextSize, ALLOWED_TEXT_OVERRIDE_ELEMENTS> = {
	"heading-1": "h1",
	"heading-2": "h2",
	"heading-3": "h3",
	"heading-4": "h4",
	"heading-5": "h5",
	"sub-heading": "h6",
	"paragraph-1": "p",
	"paragraph-2": "p",
	"paragraph-3": "p",
	caption: "p",
	"extra-small": "p",
};
